export function createEl(element, classList) {
  const el = document.createElement(element);
  el.classList.add(classList);
  return el;
}

export function elRemove(el) {
  if (!el) return;
  el.setAttribute("style", "animation: removeBlock .5s forwards");
  setTimeout(() => el.remove(), 500);
}

export function hideAllElements(arrHide) {
  arrHide.forEach((el) => {
    const element = document.querySelector(el);
    if (element) {
      elRemove(element);
    }
  });
}

export function buttonDisabled(disabled, display) {
  const spinButton = document.querySelector(".button-spin");
  const spinImg = document.querySelector(".button-spin__img");
  const spinCursor = document.querySelector(".button-spin__cursor");

  if (!spinButton || !spinImg || !spinCursor) return;

  spinButton.disabled = disabled;
  spinImg.style.animation = disabled ? "none" : "";
  spinCursor.style.display = display;
}

export function changeBackground(url) {
  const mainSection = document.querySelector(".wrap");
  if (!mainSection) return;
  mainSection.style.transition = "background-image 0.5s ease-in-out";
  mainSection.style.backgroundImage = url;
}

export function size() {
  const width = window.innerWidth;
  const height = window.innerHeight;
  const isLandscape = width > height;

  if (width >= 1280) {
    return "url(/assets/img/bgWin-xl.webp)";
  } else if (width >= 768) {
    if (isLandscape && width <= 1000) {
      return "url(/assets/img/bgWin-l.webp)";
    } else if (isLandscape) {
      return "url(/assets/img/bgWin-l.webp)";
    } else {
      return "url(/assets/img/bgWin-m.webp)";
    }
  } else if (width >= 576) {
    return "url(/assets/img/bgWin-m.webp)";
  } else {
    return "url(/assets/img/bgWin-s.webp)";
  }
}
